// SCHOCK MARKT — Multilingual content (DE / TR / EN)
// Default and primary language is German.

export const LANGS = [
    { code: "de", label: "DE", name: "Deutsch" },
    { code: "tr", label: "TR", name: "Türkçe" },
    { code: "en", label: "EN", name: "English" },
];

export const DEFAULT_LANG = "de";

export const T = {
    de: {
        nav: {
            home: "Start",
            offers: "Angebote",
            categories: "Kategorien",
            about: "Über uns",
            careers: "Karriere",
            contact: "Kontakt",
            faq: "FAQ",
        },
        cta: {
            whatsapp: "WhatsApp",
            location: "Standort ansehen",
            offers: "Angebote entdecken",
            newsletter: "Anmelden",
            apply: "Jetzt bewerben",
            send: "Senden",
            more: "Mehr erfahren",
            backHome: "Zurück zur Startseite",
        },
        hero: {
            eyebrow: "Eröffnung in Kürze · Backnang",
            soonTitlePre: "SCHOCK",
            soonTitleMid: "MARKT",
            soonTitleSuf: "kommt nach Backnang.",
            soonSubtitle:
                "Frische Produkte, faire Preise und eine große Auswahl — bald ganz in deiner Nähe.",
            livedTitle: "Frisch. Fair. Vielfalt.",
            livedSubtitle:
                "Dein Markt für die ganze Familie — Sulzbacher Straße 10, Backnang.",
            ctaWhats: "Per WhatsApp kontaktieren",
            ctaLoc: "Standort ansehen",
            ctaOffers: "Angebote entdecken",
            countdownDays: "Tage",
            countdownHours: "Std",
            countdownMin: "Min",
            countdownSec: "Sek",
            countdownPrep: "Countdown wird vom Team aktiviert, sobald das Datum offiziell ist.",
        },
        values: {
            eyebrow: "Warum SCHOCK MARKT",
            title: "Mehr als nur ein Supermarkt.",
            subtitle:
                "Vier Versprechen, die wir jeden Tag einlösen — für ein Einkaufserlebnis, das sich gut anfühlt.",
            items: [
                {
                    t: "Frische Produkte",
                    d: "Täglich frische Auswahl direkt aus der Region und sorgfältig kuratiert.",
                },
                {
                    t: "Faire Preise",
                    d: "Ehrliche Preise ohne Tricks — gut für deinen Geldbeutel und deine Familie.",
                },
                {
                    t: "Große Auswahl",
                    d: "Vom Alltag bis zur Spezialität: internationale Marken und lokale Klassiker.",
                },
                {
                    t: "Für Backnang",
                    d: "Ein Markt für die Nachbarschaft — gemacht für die Menschen in unserer Stadt.",
                },
            ],
        },
        categories: {
            eyebrow: "Unser Sortiment",
            title: "Alles, was deine Familie braucht.",
            subtitle: "Acht starke Bereiche unter einem Dach.",
        },
        offers: {
            eyebrow: "Wochenangebote",
            title: "Frische Aktionen jede Woche.",
            subtitle:
                "Handverlesene Highlights zu Top-Preisen — solange der Vorrat reicht.",
            old: "Alter Preis",
            new: "Aktion",
            save: "Spare",
            until: "Gültig bis",
            featured: "Ausgewählte Angebote",
            all: "Alle Angebote",
            allCategories: "Alle Kategorien",
            empty: "Aktuell sind keine Angebote eingestellt. Schaue bald wieder vorbei.",
            heroDesc:
                "Stark reduziert: Top-Marken, Frische und Klassiker. Jede Woche neu — direkt in deinem Markt in Backnang.",
        },
        about: {
            eyebrow: "Über SCHOCK MARKT",
            title: "Dein Markt für die ganze Familie.",
            body1:
                "SCHOCK MARKT steht für frische Qualität, ein starkes Sortiment und ein Einkaufserlebnis für die ganze Familie. Direkt in Backnang — modern, nah und zuverlässig.",
            body2:
                "Wir glauben, dass ein guter Markt mehr ist als nur Regale: Er ist Teil der Nachbarschaft. Deshalb verbinden wir deutsche Retail-Standards mit einem warmen, persönlichen Service.",
            pointsTitle: "Unsere Werte",
            points: [
                "Konsequente Frische — geprüft, bevor wir verkaufen.",
                "Faire Preise — fair gegenüber Familien und Erzeugern.",
                "Lokale Verbundenheit — Backnang ist unser Zuhause.",
                "Vielfalt — deutsche, türkische und internationale Klassiker.",
            ],
        },
        opening: {
            eyebrow: "Eröffnung",
            title: "Wir starten in Kürze.",
            body:
                "Sei dabei, wenn SCHOCK MARKT in Backnang öffnet — sichere dir Updates und exklusive Eröffnungsangebote.",
            announce: "Eröffnung in Kürze.",
            placeholderDate: "Datum wird in Kürze bekannt gegeben.",
            jetztGeoeffnet: "Jetzt geöffnet",
        },
        location: {
            eyebrow: "Standort",
            title: "Finde uns in Backnang.",
            address: "Sulzbacher Straße 10, 71522 Backnang",
            hours: "Öffnungszeiten",
            directions: "Route planen",
            parking: "Kostenlose Parkplätze vor dem Markt.",
            daysShort: {
                monday: "Montag",
                tuesday: "Dienstag",
                wednesday: "Mittwoch",
                thursday: "Donnerstag",
                friday: "Freitag",
                saturday: "Samstag",
                sunday: "Sonntag",
            },
        },
        whatsappCta: {
            eyebrow: "Direktkontakt",
            title: "Fragen? Schreib uns auf WhatsApp.",
            body: "Wir antworten schnell und persönlich — direkt aus dem Markt.",
            cta: "Per WhatsApp schreiben",
        },
        newsletter: {
            eyebrow: "Newsletter",
            title: "Bleibe informiert.",
            body: "Eröffnungsdatum, Wochenangebote und exklusive Aktionen — direkt in dein Postfach.",
            emailPlaceholder: "Deine E-Mail-Adresse",
            consent:
                "Ich stimme der Verarbeitung meiner E-Mail-Adresse zum Versand des Newsletters zu. Abmeldung jederzeit möglich.",
            success: "Danke! Wir melden uns bald.",
        },
        careers: {
            eyebrow: "Karriere",
            title: "Werde Teil unseres Teams.",
            body:
                "Wir suchen Menschen, die mit Herz und Freundlichkeit für unsere Kundschaft da sind. Bewirb dich jetzt — wir freuen uns auf dich.",
            why: "Warum SCHOCK MARKT?",
            whyPoints: [
                "Stabiler Arbeitsplatz in einer wachsenden Marke.",
                "Familiäres Team mit kurzen Wegen.",
                "Faire Bezahlung und Wertschätzung.",
                "Entwicklungsmöglichkeiten ab Tag 1.",
            ],
            openTitle: "Offene Stellen",
            positions: [
                "Marktleitung (m/w/d)",
                "Kassenkraft (m/w/d)",
                "Mitarbeiter Obst & Gemüse (m/w/d)",
                "Mitarbeiter Bäckerei (m/w/d)",
                "Mitarbeiter Fleischtheke (m/w/d)",
                "Initiativbewerbung",
            ],
            form: {
                name: "Name",
                email: "E-Mail",
                phone: "Telefon",
                position: "Position",
                message: "Nachricht (optional)",
                cv: "Lebenslauf hochladen (PDF, DOC, max. 8 MB)",
                consent:
                    "Ich stimme der Verarbeitung meiner Bewerbungsunterlagen gemäß Datenschutzerklärung zu.",
                success: "Vielen Dank! Deine Bewerbung ist eingegangen.",
            },
        },
        contact: {
            eyebrow: "Kontakt",
            title: "Wir sind für dich da.",
            body:
                "Hast du Fragen zu unserem Markt, einem Produkt oder einer Anfrage? Schreib uns — wir melden uns schnell zurück.",
            form: {
                name: "Name",
                email: "E-Mail",
                phone: "Telefon (optional)",
                subject: "Betreff",
                message: "Deine Nachricht",
                consent:
                    "Ich stimme der Verarbeitung meiner Daten zur Beantwortung meiner Anfrage zu.",
                success: "Danke! Deine Nachricht ist eingegangen.",
            },
        },
        faq: {
            eyebrow: "Häufige Fragen",
            title: "Antworten auf einen Blick.",
            body: "Findest du nichts? Schreib uns — wir helfen gern weiter.",
        },
        footer: {
            tagline: "Frisch. Fair. Vielfalt.",
            quick: "Schnelllinks",
            legal: "Rechtliches",
            contact: "Kontakt",
            impressum: "Impressum",
            datenschutz: "Datenschutz",
            cookies: "Cookies",
            copyright: "© 2026 SCHOCK MARKT. Alle Rechte vorbehalten.",
        },
        legal: {
            impressum: {
                title: "Impressum",
                body: "Angaben gemäß § 5 TMG. (Platzhalter — bitte vor dem Launch durch die finalen Firmendaten ersetzen.)",
            },
            datenschutz: {
                title: "Datenschutzerklärung",
                body: "Wir verarbeiten personenbezogene Daten ausschließlich auf Grundlage der DSGVO. (Platzhalter — finale Fassung folgt vor Eröffnung.)",
            },
            cookies: {
                title: "Cookie-Einstellungen",
                body: "Diese Website verwendet nur essenzielle Cookies. Eine ausführliche Beschreibung erfolgt in Kürze.",
            },
        },
        admin: {
            login: "Admin-Anmeldung",
            email: "E-Mail",
            password: "Passwort",
            signIn: "Anmelden",
            signOut: "Abmelden",
            dashboard: "Dashboard",
            settings: "Einstellungen",
            offers: "Angebote",
            categories: "Kategorien",
            faqs: "FAQ",
            applications: "Bewerbungen",
            newsletterLeads: "Newsletter",
            contactMessages: "Nachrichten",
            siteMode: "Site-Modus",
            openingSoon: "Eröffnung in Kürze",
            storeLive: "Markt geöffnet",
        },
    },

    tr: {
        nav: {
            home: "Anasayfa",
            offers: "Fırsatlar",
            categories: "Kategoriler",
            about: "Hakkımızda",
            careers: "Kariyer",
            contact: "İletişim",
            faq: "SSS",
        },
        cta: {
            whatsapp: "WhatsApp",
            location: "Konum",
            offers: "Fırsatları keşfet",
            newsletter: "Abone ol",
            apply: "Hemen başvur",
            send: "Gönder",
            more: "Daha fazla",
            backHome: "Anasayfaya dön",
        },
        hero: {
            eyebrow: "Yakında açılıyor · Backnang",
            soonTitlePre: "SCHOCK",
            soonTitleMid: "MARKT",
            soonTitleSuf: "Backnang'a geliyor.",
            soonSubtitle:
                "Taze ürünler, uygun fiyatlar ve geniş seçenek — yakında size çok yakın.",
            livedTitle: "Taze. Adil. Çeşitlilik.",
            livedSubtitle: "Tüm aile için marketiniz — Sulzbacher Straße 10, Backnang.",
            ctaWhats: "WhatsApp ile yazın",
            ctaLoc: "Konuma git",
            ctaOffers: "Fırsatları gör",
            countdownDays: "Gün",
            countdownHours: "Saat",
            countdownMin: "Dk",
            countdownSec: "Sn",
            countdownPrep: "Tarih kesinleştiğinde geri sayım aktif olacak.",
        },
        values: {
            eyebrow: "Neden SCHOCK MARKT",
            title: "Bir markeden çok daha fazlası.",
            subtitle: "Her gün tuttuğumuz dört söz.",
            items: [
                { t: "Taze ürünler", d: "Her gün taze ve özenle seçilmiş ürünler." },
                { t: "Uygun fiyat", d: "Aile bütçesine uygun, dürüst fiyatlar." },
                { t: "Geniş seçenek", d: "Günlük ihtiyaçtan özel lezzetlere kadar." },
                { t: "Backnang için", d: "Mahallenizin marketi, sizin için kuruldu." },
            ],
        },
        categories: {
            eyebrow: "Ürün Yelpazemiz",
            title: "Ailenizin ihtiyacı olan her şey.",
            subtitle: "Tek çatı altında sekiz güçlü bölüm.",
        },
        offers: {
            eyebrow: "Haftalık fırsatlar",
            title: "Her hafta taze indirimler.",
            subtitle: "Özenle seçilmiş ürünler, harika fiyatlarla.",
            old: "Eski fiyat",
            new: "İndirimli",
            save: "Kazanç",
            until: "Geçerlilik",
            featured: "Öne çıkanlar",
            all: "Tüm fırsatlar",
            allCategories: "Tüm kategoriler",
            empty: "Şu anda yayında bir fırsat yok. Yakında tekrar bakın.",
            heroDesc:
                "Güçlü indirimler: en sevilen markalar, tazelik ve klasikler. Her hafta yenisi — Backnang'daki marketinizde.",
        },
        about: {
            eyebrow: "SCHOCK MARKT Hakkında",
            title: "Tüm aile için marketiniz.",
            body1:
                "SCHOCK MARKT taze kalite, geniş ürün yelpazesi ve aileye yönelik bir alışveriş deneyimi sunar. Backnang'da — modern, yakın ve güvenilir.",
            body2:
                "Bir marketin sadece raflardan ibaret olmadığına inanıyoruz. O mahallenin bir parçasıdır. Bu nedenle Alman perakende standartlarını sıcak ve kişisel bir hizmetle birleştiriyoruz.",
            pointsTitle: "Değerlerimiz",
            points: [
                "Kararlı tazelik — satmadan önce kontrol.",
                "Adil fiyatlar — ailelere ve üreticilere karşı dürüstlük.",
                "Yerel bağ — Backnang bizim evimiz.",
                "Çeşitlilik — Alman, Türk ve uluslararası klasikler.",
            ],
        },
        opening: {
            eyebrow: "Açılış",
            title: "Yakında açılıyoruz.",
            body:
                "Backnang'da SCHOCK MARKT açılırken siz de yanımızda olun — açılış kampanyalarımızdan ilk siz haberdar olun.",
            announce: "Yakında açılıyor.",
            placeholderDate: "Açılış tarihi yakında duyurulacaktır.",
            jetztGeoeffnet: "Şu anda açığız",
        },
        location: {
            eyebrow: "Konum",
            title: "Bizi Backnang'da bulun.",
            address: "Sulzbacher Straße 10, 71522 Backnang",
            hours: "Çalışma saatleri",
            directions: "Yol tarifi",
            parking: "Marketin önünde ücretsiz otopark.",
            daysShort: {
                monday: "Pazartesi",
                tuesday: "Salı",
                wednesday: "Çarşamba",
                thursday: "Perşembe",
                friday: "Cuma",
                saturday: "Cumartesi",
                sunday: "Pazar",
            },
        },
        whatsappCta: {
            eyebrow: "Direkt iletişim",
            title: "Sorularınız mı var? WhatsApp'tan yazın.",
            body: "Hızlı ve kişisel cevaplar — doğrudan marketten.",
            cta: "WhatsApp'tan yaz",
        },
        newsletter: {
            eyebrow: "Bülten",
            title: "Haberdar olun.",
            body: "Açılış tarihi, haftalık fırsatlar ve özel kampanyalar — doğrudan e-postanıza.",
            emailPlaceholder: "E-posta adresiniz",
            consent:
                "E-posta adresimin bülten gönderimi amacıyla işlenmesini kabul ediyorum. İstediğim zaman iptal edebilirim.",
            success: "Teşekkürler! Yakında size ulaşacağız.",
        },
        careers: {
            eyebrow: "Kariyer",
            title: "Ekibimize katılın.",
            body: "Müşterilerimize sıcaklıkla yaklaşan ekip arkadaşları arıyoruz. Sizi tanımak için sabırsızlanıyoruz.",
            why: "Neden SCHOCK MARKT?",
            whyPoints: [
                "Büyüyen bir markada istikrarlı iş.",
                "Sıcak ve kısa yollu bir ekip.",
                "Adil ücret ve takdir.",
                "İlk günden gelişim fırsatları.",
            ],
            openTitle: "Açık pozisyonlar",
            positions: [
                "Market Müdürü (k/e)",
                "Kasiyer (k/e)",
                "Meyve & Sebze Görevlisi (k/e)",
                "Fırın Görevlisi (k/e)",
                "Et Reyonu Görevlisi (k/e)",
                "Spontane başvuru",
            ],
            form: {
                name: "Ad Soyad",
                email: "E-posta",
                phone: "Telefon",
                position: "Pozisyon",
                message: "Mesaj (opsiyonel)",
                cv: "Özgeçmiş yükle (PDF, DOC, en fazla 8 MB)",
                consent:
                    "Başvuru belgelerimin gizlilik politikası kapsamında işlenmesini kabul ediyorum.",
                success: "Teşekkürler! Başvurunuz alındı.",
            },
        },
        contact: {
            eyebrow: "İletişim",
            title: "Buradayız.",
            body: "Marketimiz, bir ürün veya başka bir konu hakkında sorularınız mı var? Bize yazın.",
            form: {
                name: "Ad Soyad",
                email: "E-posta",
                phone: "Telefon (opsiyonel)",
                subject: "Konu",
                message: "Mesajınız",
                consent: "Talebimin yanıtlanması için verilerimin işlenmesini kabul ediyorum.",
                success: "Teşekkürler! Mesajınız alındı.",
            },
        },
        faq: {
            eyebrow: "Sık sorulanlar",
            title: "Cevaplar tek bakışta.",
            body: "Aradığınızı bulamadınız mı? Bize yazın — yardımcı olalım.",
        },
        footer: {
            tagline: "Taze. Adil. Çeşitlilik.",
            quick: "Hızlı bağlantılar",
            legal: "Yasal",
            contact: "İletişim",
            impressum: "Künye",
            datenschutz: "Gizlilik",
            cookies: "Çerezler",
            copyright: "© 2026 SCHOCK MARKT. Tüm hakları saklıdır.",
        },
        legal: {
            impressum: {
                title: "Künye",
                body: "§ 5 TMG kapsamında bilgiler. (Yer tutucu — açılış öncesi nihai bilgilerle güncellenecektir.)",
            },
            datenschutz: {
                title: "Gizlilik Politikası",
                body: "Kişisel verileri yalnızca GDPR (KVKK) çerçevesinde işliyoruz. (Yer tutucu — nihai metin açılıştan önce yayınlanacaktır.)",
            },
            cookies: {
                title: "Çerez ayarları",
                body: "Bu site yalnızca temel çerezleri kullanır. Detaylı açıklama yakında yayınlanacaktır.",
            },
        },
        admin: {
            login: "Yönetici Girişi",
            email: "E-posta",
            password: "Şifre",
            signIn: "Giriş yap",
            signOut: "Çıkış",
            dashboard: "Panel",
            settings: "Ayarlar",
            offers: "Fırsatlar",
            categories: "Kategoriler",
            faqs: "SSS",
            applications: "Başvurular",
            newsletterLeads: "Bülten",
            contactMessages: "Mesajlar",
            siteMode: "Site modu",
            openingSoon: "Yakında açılıyor",
            storeLive: "Market açık",
        },
    },

    en: {
        nav: {
            home: "Home",
            offers: "Weekly Offers",
            categories: "Categories",
            about: "About",
            careers: "Careers",
            contact: "Contact",
            faq: "FAQ",
        },
        cta: {
            whatsapp: "WhatsApp",
            location: "View location",
            offers: "Discover offers",
            newsletter: "Subscribe",
            apply: "Apply now",
            send: "Send",
            more: "Learn more",
            backHome: "Back to homepage",
        },
        hero: {
            eyebrow: "Opening soon · Backnang",
            soonTitlePre: "SCHOCK",
            soonTitleMid: "MARKT",
            soonTitleSuf: "is coming to Backnang.",
            soonSubtitle:
                "Fresh products, fair prices and a wide selection — right around the corner.",
            livedTitle: "Fresh. Fair. Variety.",
            livedSubtitle:
                "Your market for the whole family — Sulzbacher Straße 10, Backnang.",
            ctaWhats: "Message us on WhatsApp",
            ctaLoc: "View location",
            ctaOffers: "Discover offers",
            countdownDays: "Days",
            countdownHours: "Hrs",
            countdownMin: "Min",
            countdownSec: "Sec",
            countdownPrep: "The countdown will go live once the opening date is confirmed.",
        },
        values: {
            eyebrow: "Why SCHOCK MARKT",
            title: "More than a supermarket.",
            subtitle: "Four promises we keep — every single day.",
            items: [
                { t: "Fresh products", d: "Daily fresh, locally sourced and carefully curated." },
                { t: "Fair prices", d: "Honest pricing — kind to your wallet and your family." },
                { t: "Wide selection", d: "From daily essentials to specialties, local and international." },
                { t: "For Backnang", d: "A neighborhood market built for the people of our town." },
            ],
        },
        categories: {
            eyebrow: "Our assortment",
            title: "Everything your family needs.",
            subtitle: "Eight strong departments under one roof.",
        },
        offers: {
            eyebrow: "Weekly offers",
            title: "Fresh deals every week.",
            subtitle: "Handpicked highlights at top prices — while stocks last.",
            old: "Old price",
            new: "Now",
            save: "Save",
            until: "Valid until",
            featured: "Featured offers",
            all: "All offers",
            allCategories: "All categories",
            empty: "No offers are live right now. Please check back soon.",
            heroDesc:
                "Sharp prices on top brands, freshness and classics. New every week — directly in your market in Backnang.",
        },
        about: {
            eyebrow: "About SCHOCK MARKT",
            title: "A market for the whole family.",
            body1:
                "SCHOCK MARKT stands for fresh quality, a strong assortment and a shopping experience for the whole family. Right here in Backnang — modern, close and reliable.",
            body2:
                "We believe a great market is more than shelves: it's part of the neighborhood. That's why we pair German retail standards with warm, personal service.",
            pointsTitle: "Our values",
            points: [
                "Relentless freshness — checked before we sell.",
                "Fair prices — fair to families and producers.",
                "Local roots — Backnang is our home.",
                "Variety — German, Turkish and international classics.",
            ],
        },
        opening: {
            eyebrow: "Opening",
            title: "We're opening soon.",
            body:
                "Be there when SCHOCK MARKT opens in Backnang — get updates and exclusive opening deals.",
            announce: "Opening soon.",
            placeholderDate: "Opening date will be announced shortly.",
            jetztGeoeffnet: "Now open",
        },
        location: {
            eyebrow: "Location",
            title: "Find us in Backnang.",
            address: "Sulzbacher Straße 10, 71522 Backnang",
            hours: "Opening hours",
            directions: "Get directions",
            parking: "Free parking right in front of the store.",
            daysShort: {
                monday: "Monday",
                tuesday: "Tuesday",
                wednesday: "Wednesday",
                thursday: "Thursday",
                friday: "Friday",
                saturday: "Saturday",
                sunday: "Sunday",
            },
        },
        whatsappCta: {
            eyebrow: "Direct contact",
            title: "Questions? Message us on WhatsApp.",
            body: "Quick, personal answers — straight from the store.",
            cta: "Message on WhatsApp",
        },
        newsletter: {
            eyebrow: "Newsletter",
            title: "Stay in the loop.",
            body: "Opening date, weekly offers and exclusive promos — straight to your inbox.",
            emailPlaceholder: "Your email address",
            consent:
                "I agree to the processing of my email address for the purpose of the newsletter. I can unsubscribe at any time.",
            success: "Thanks! We'll be in touch soon.",
        },
        careers: {
            eyebrow: "Careers",
            title: "Join our team.",
            body: "We're looking for friendly people who love serving their neighborhood. Apply today.",
            why: "Why SCHOCK MARKT?",
            whyPoints: [
                "Stable job at a growing brand.",
                "Friendly team with short decision paths.",
                "Fair pay and genuine appreciation.",
                "Growth opportunities from day one.",
            ],
            openTitle: "Open positions",
            positions: [
                "Store Manager (f/m/d)",
                "Cashier (f/m/d)",
                "Fruit & Vegetables Associate (f/m/d)",
                "Bakery Associate (f/m/d)",
                "Meat Counter Associate (f/m/d)",
                "Open application",
            ],
            form: {
                name: "Name",
                email: "Email",
                phone: "Phone",
                position: "Position",
                message: "Message (optional)",
                cv: "Upload CV (PDF, DOC, max. 8 MB)",
                consent: "I agree to the processing of my application according to the privacy policy.",
                success: "Thanks! Your application has been received.",
            },
        },
        contact: {
            eyebrow: "Contact",
            title: "We're here for you.",
            body: "Questions about our store, a product or anything else? Send a message — we'll get back quickly.",
            form: {
                name: "Name",
                email: "Email",
                phone: "Phone (optional)",
                subject: "Subject",
                message: "Your message",
                consent: "I agree to the processing of my data to respond to my request.",
                success: "Thanks! Your message has been received.",
            },
        },
        faq: {
            eyebrow: "FAQ",
            title: "Answers at a glance.",
            body: "Can't find what you're looking for? Write to us — we're happy to help.",
        },
        footer: {
            tagline: "Fresh. Fair. Variety.",
            quick: "Quick links",
            legal: "Legal",
            contact: "Contact",
            impressum: "Imprint",
            datenschutz: "Privacy",
            cookies: "Cookies",
            copyright: "© 2026 SCHOCK MARKT. All rights reserved.",
        },
        legal: {
            impressum: {
                title: "Imprint",
                body: "Information pursuant to § 5 TMG. (Placeholder — to be replaced with final company data prior to launch.)",
            },
            datenschutz: {
                title: "Privacy Policy",
                body: "We process personal data only under the GDPR. (Placeholder — final version published before opening.)",
            },
            cookies: {
                title: "Cookie settings",
                body: "This site uses essential cookies only. A detailed description will follow shortly.",
            },
        },
        admin: {
            login: "Admin Login",
            email: "Email",
            password: "Password",
            signIn: "Sign in",
            signOut: "Sign out",
            dashboard: "Dashboard",
            settings: "Settings",
            offers: "Offers",
            categories: "Categories",
            faqs: "FAQ",
            applications: "Applications",
            newsletterLeads: "Newsletter",
            contactMessages: "Messages",
            siteMode: "Site mode",
            openingSoon: "Opening soon",
            storeLive: "Store live",
        },
    },
};

export const pick = (obj, lang, fallback = "de") => {
    if (!obj) return "";
    if (typeof obj === "string") return obj;
    return obj[lang] || obj[fallback] || Object.values(obj)[0] || "";
};
